<template>
  <div>
    <vue-headful title="About"/>
    <Navbar />
    <a-table
      :columns="columns"
      rowKey="key"
      :data-source="data"
      class="components-table-demo-nested"
    >
      <a slot="operation">Publish</a>
      <a-table
        slot="expandedRowRender"
        rowKey="key"
        slot-scope="record"
        :columns="innerColumns"
        :data-source="record.indata"
        :pagination="false"
      >
        <span slot="status">
          <a-badge status="success" />Finished
        </span>
        <span slot="operation" class="table-operation">
          <a>Pause</a>
          <a>Stop</a>
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item>Action 1</a-menu-item>
              <a-menu-item>Action 2</a-menu-item>
            </a-menu>
            <a>
              More
              <a-icon type="down" />
            </a>
          </a-dropdown>
        </span>
      </a-table>
    </a-table>
  </div>
</template>
<script>
const columns = [
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Platform", dataIndex: "platform", key: "platform" },
  { title: "Version", dataIndex: "version", key: "version" },
  { title: "Upgraded", dataIndex: "upgradeNum", key: "upgradeNum" },
  { title: "Creator", dataIndex: "creator", key: "creator" },
  { title: "Date", dataIndex: "createdAt", key: "createdAt" },
  {
    title: "Action",
    key: "operation",
    scopedSlots: { customRender: "operation" },
  },
];

const data = [];
for (let i = 0; i < 3; ++i) {
  data.push({
    key: i,
    name: "Screem",
    platform: "iOS",
    version: "10.3.4.5654",
    upgradeNum: 500,
    creator: "Jack",
    createdAt: "2014-12-24 23:12:00",
    indata: [
      {
        key: i,
        name: "anne" + i,
        total: 100 * i,
      },
      {
        key: i + 10,
        name: "bnne" + i,
        total: 200 * i,
      },
    ],
  });
}

const innerColumns = [
  { title: "key", dataIndex: "key", key: "key" },
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "total", dataIndex: "total", key: "total" },
];

import Navbar from "@/components/Navbar.vue";
export default {
  components: {
    Navbar,
  },
  data() {
    return {
      data,
      columns,
      innerColumns,
    };
  },
  methods: {
    test() {
      this.data[0].indata.splice(0, 1);
    },
  },
};
</script>